var _style, _rect, _path, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "15 0 421.8 170.1",
    width: 412,
    height: 170,
    style: {
      enableBackground: "new 0 0 451.8 170.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.logo-background{fill:#ED1C24;}\r\n\t.logo-inscription{fill:#FFFFFF;}\r\n\t.right-gradient{fill:url(#SVGID_1_);}\r\n\t.left-gradient{fill:url(#SVGID_2_);}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.1,
    className: "logo-background",
    width: 389.7,
    height: 170.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo-inscription",
    d: "M79.8,53.4c24.3-9.1,51.8-15,79.9-10.9l2.9-5.3c5.8-0.9,11.7-1.7,17.5-2.3l-7.8,11.9 c7.6,3.3,13.9,11.3,14.6,19.7c0,11.4-5.1,20.9-10.9,29.7l8.5-1c5.7-9.3,21.7-20.5,28.3-12l2.3-3.2c0,0,10.5-1.6,10.7-1.6 c-9.3,17.3-14.3,22-13.1,23.6c1.4,1.9,18.4-13.2,24.8-25.5l10.1-1.1l-5.7,10.1c10.2-8.4,13.9-13.8,19.6-11.4 c7.9,3.3-9.4,21.7-7.5,22.9c1.6,1,15.5-9.2,22.2-19.5l-9.5,1.5l3.3-6.2l9.4-1.2c10.2-18.8,37-54.7,45.2-49.4 c7.6,4.9-10.7,28.7-34.7,45.9l-1.5,2.7l20.8-2.3c0.4,0.2,0.6,0.9,0.1,1.3c-6.7,5.7-19.9,19.6-13,23.9c6.1,2.2,15.6-11.9,16.5-14.8 c-5.4-1.7-1.1-16.8,6.6-14.8c5.2,1.8,1.3,9.2,0,12.1c9.9-1.2,18.8-11.3,18.8-11.3c-0.1-8,5-16.6,10.9-14.5c3.8,2,0.7,7.7-5.6,14.4 c-0.8,0.8-0.4,3.9-0.5,7.6c6.7-2.3,14.3-5.5,20.6-8.6c0.1-7.7,3.9-17,10.4-15.1c4.7,1.4,0,10.9-5.9,15.7c-0.1,10.3,1.6,17.1-1,22.5 c-3,6.2-13.4,11.4-19.6,7.8c-6.4-3.7-0.7-12,3.2-15.1c3.5-2.9,12.4-7,12.4-7s0.5-3.5,0.3-5.2c-3.5,2.1-20.2,8.3-20.2,8.3 c-0.7,6.1-0.6,8.6-3.5,14.2c-3.6,6.9-15.5,9.7-19.5,5.8c-2.8-2.7-2-9.2,3.8-13.8c4.3-3.5,13.5-7.3,13.5-7.3s0.8-3.5,0.5-4.9 c-5.9,5.1-12.6,10.2-21.2,10.4l0,0c-5.2,10.4-19.1,24.8-29,18.3c-9.6-6.2,5.8-22.6,7.4-23.8c-3.2,0.2-9.6,1.6-9.6,1.6l-16.9,31.3 l0.2-0.1c0,0,57.7-6.6,110.1-6.7l-6.3,5.9c3,2.1,6.1,4.2,9.3,6c0,0-54.6-2.4-117.5,2.8l-9.2,17.1l-11.4,0.8l9.9-17.1 c0,0-28.6,0.9-91.4,9.4c0.7-1.3,0.9-1.6,1.9-3.3c55.7-11.2,93.6-14,93.6-14s8.8-15.1,8.4-14.8c-5.5,4.6-17.7,14.4-22.8,9.6 c-3.7-4.6,9.2-19.3,7.7-20.5c-1.2-1-16.5,14.7-22,23.3c-3.1,0.2-8.9,0.9-8.9,0.9l4.4-8.6c-5,3.9-10.3,8.1-15.9,10.3 c-1.6,0.6-5.2,0.8-6.7-3.4c0,0-11.3,10.2-18.9,6.3c-4.1-2.1-2.2-9.8-1.5-11.5l-9,1c-39,45.2-89.9,50.3-96,40.4 c-6.5-10.6,16.6-24.8,48.2-34.8c0,0,28.1-50.6,27.6-51c-38.8-5.9-86.8,23.9-86.8,23.9L79.8,53.4z M94.5,134.9 c4.6,5.8,42.7-0.3,68.5-32.3c-17.8,2.8-28.4,6.6-32.3,8c-8.4,13.7-11.9,18.7-15.1,18.2c-3.9-0.5,2.3-7.9,5.6-15 C107.2,118.4,90.3,129.5,94.5,134.9z M135.7,103.3c10-2.7,25.6-5.2,30.9-5.8c4.5-7.3,19.1-31.6-1.8-39.2L135.7,103.3z M196,93.1 c-3,4-6.2,10.7-3.8,12.6c2.5,1.9,9.3-4,11.6-6.9c3.9-5.1,7.1-12.1,4.7-13.4C204.7,83.4,198.1,90.3,196,93.1z M294.2,59.6 c7.6-4.7,27-24,22.2-28.5C311.4,28.9,298.1,50.4,294.2,59.6z M328.8,82.5c-3.2,2.3-4.8,5.2-3.2,6.5c1.5,1.2,5.5-1.1,7.2-3.6 c2.8-3.8,3.4-7.1,3.4-7.1S333.7,78.9,328.8,82.5z M354.1,81.2c-1.1,1-5.2,4.7-3.4,6.5c1.5,1.6,6-1.1,7.8-3.2 c2.4-2.9,3.6-7.5,3.6-7.5S357.3,78.4,354.1,81.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -2580.9507,
    cy: -3762.8328,
    r: 537.4837,
    fx: -2643.8372,
    fy: -3693.3677,
    gradientTransform: "matrix(-6.887427e-02 0.8294 2.922520e-02 4.132971e-03 354.2026 2148.9148)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#871518"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    style: {
      stopColor: "#881919",
      stopOpacity: 0.865
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    style: {
      stopColor: "#8C241E",
      stopOpacity: 0.7382
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#933427",
      stopOpacity: 0.6147
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    style: {
      stopColor: "#9E4938",
      stopOpacity: 0.493
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6272,
    style: {
      stopColor: "#AB6250",
      stopOpacity: 0.3728
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    style: {
      stopColor: "#BE8371",
      stopOpacity: 0.2536
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8647,
    style: {
      stopColor: "#D5B0A2",
      stopOpacity: 0.1353
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9795,
    style: {
      stopColor: "#F5ECE8",
      stopOpacity: 0.02049065
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 420.7,
    className: "right-gradient",
    width: 31.1,
    height: 170.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: -2237.3267,
    cy: 5977.293,
    r: 537.4837,
    fx: -2300.2131,
    fy: 6046.7583,
    gradientTransform: "matrix(6.887427e-02 0.8294 -2.922520e-02 4.132971e-03 358.5845 1823.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#871518"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    style: {
      stopColor: "#881919",
      stopOpacity: 0.865
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    style: {
      stopColor: "#8C241E",
      stopOpacity: 0.7382
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#933427",
      stopOpacity: 0.6147
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    style: {
      stopColor: "#9E4938",
      stopOpacity: 0.493
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6272,
    style: {
      stopColor: "#AB6250",
      stopOpacity: 0.3728
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7464,
    style: {
      stopColor: "#BE8371",
      stopOpacity: 0.2536
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8647,
    style: {
      stopColor: "#D5B0A2",
      stopOpacity: 0.1353
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9795,
    style: {
      stopColor: "#F5ECE8",
      stopOpacity: 0.02049065
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "left-gradient",
    width: 31.1,
    height: 170.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.51f7e13332ed55e29527bb488e4f84d3.svg";
export { ForwardRef as ReactComponent };